import MainShaftUnbalanceMutations from "./MainShaftUnbalanceMutations";
import MainShaftUnbalanceGetters from "./MainShaftUnbalanceGetters";
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import MainShaftUnbalanceActions from "./MainShaftUnbalanceActions";

const { getters } = MainShaftUnbalanceGetters;

const state = {
	status:             FetchStatus.Init,
	successMessage:     "",
	errorMessage:       "",
	operatingRange:     0,
	frequencyChartData: [],
	signalSettingIds:   [],
	orderChartData:     [],
	orderLayout:        {},
	frequencyLayout:    {},
};

const { actions } = MainShaftUnbalanceActions;

const { mutations } = MainShaftUnbalanceMutations;

const namespaced = true;

export default {
	state,
	actions,
	mutations,
	getters,
	namespaced,
};
